import UserWrap from './UserWrap';

export default UserWrap;


// WEBPACK FOOTER //
// ./src/components/UserWrap/index.tsx